<ng-container *ngIf="(workerStatus$|async) as status">
  <div *ngIf="workId" appFlexLayout="row" appFlexAlign="center center">

    <div appFlex appFlexAlign="center center">
      <mat-icon style="color: lightgrey;"
                [matTooltip]="('En cours de traitement'|translate)">engineering
      </mat-icon>
    </div>

    <dx-progress-bar
      class="ml-8"
      appFlex="90"
      *ngIf="status.isWorking && status?.progress?.max"
      #progressBar
      id="progress-bar-status"
      width="100%"

      [showStatus]="true"

      [min]="0"
      [max]="status?.progress?.max"
      [value]="curStep"

    >
    </dx-progress-bar>

  </div>
</ng-container>
